const { Resources } = require('./Resources');
const { CreateResource } = require('./CreateResource');
const { UpdateResource } = require('./UpdateResource');

export { Resources, CreateResource, UpdateResource };
